import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board7 from '../images/board7.jpg'

export function A07({ index }) {
  return (
    <Article
      index={index}
      heading="CanCan is now a full-fledged open internet service."
      image={board7}
      imageDescription="People discuss, use, and develop for the CanCan service."
    >
      <div className="article-row">
        <span>
          <p>
            Now that CanCan has its own governance system, outside developers
            contributing to it, and users being rewarded for moderating its
            content, the app has successfully established itself as an open
            internet service.
            <br />
            <br />
            Because the app is hosted on the Internet Computer, CanCan scales
            and stays online without constant human maintenance, and exists not
            in any one jurisdiction but across many countries around the world.
            Outside developers can code new features for the app and submit them
            as proposals to be voted on by the governance community, and the
            app's tokenized engagement drives growth with tokenized viral loops
            rather than ad spend.
            <br />
            <br />
            CanCan is now a service that truly runs as part of the internet. As
            it scales, its cultural importance grows and so does its tokenized
            economy, creating a virtuous loop.
          </p>
        </span>
        <aside>
          <h4>Interoperable Open Internet Services</h4>
          <p>
            The Internet Computer makes possible a next-generation ecosystem of
            interoperable open internet services.
          </p>
        </aside>
      </div>
    </Article>
  )
}

A07.propTypes = {
  index: PropTypes.number.isRequired,
}
